import { render, staticRenderFns } from "./AdminRosterStudents.vue?vue&type=template&id=8808320e&scoped=true&"
import script from "./AdminRosterStudents.vue?vue&type=script&lang=js&"
export * from "./AdminRosterStudents.vue?vue&type=script&lang=js&"
import style0 from "./AdminRosterStudents.vue?vue&type=style&index=0&id=8808320e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8808320e",
  null
  
)

export default component.exports